import { useState } from 'react';

import RefreshButton from '../../../../atoms/RefreshButton';
import PageFooter from '../../../../molecules/PageFooter';
import { OutboxSummary, eventingApi } from '../../../../../services/eventingApi';
import { useApiResource } from '../hooks/useApiResource';
import ResourceState from '../shared/ResourceState';
import { Section } from '../shared/ui';
import OutboxTable from './OutboxTable';
import SourceServiceSelect from './SourceServiceSelect';

const DEFAULT_PAGE_SIZE = 100;

const OutboxTab = ({ services }: { services: OutboxSummary[] }) => {
  const [sourceService, setSourceService] = useState('');
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(DEFAULT_PAGE_SIZE);
  const entries = useApiResource(
    () => eventingApi.listOutboxEntries({ sourceService: sourceService || undefined, page: page + 1, size }),
    [sourceService, page, size],
  );
  const total = Number(entries.meta?.total ?? 0);
  const rows = entries.data ?? [];

  const changeService = (value: string) => {
    setSourceService(value);
    setPage(0);
  };

  const changeSize = (value: number) => {
    setSize(value);
    setPage(0);
  };

  return (
    <Section
      title={`Outbox pendente (${total})`}
      subtitle="Linhas que o varredor ainda não publicou; o payload não é exibido"
      actions={
        <>
          <SourceServiceSelect services={services} value={sourceService} onChange={changeService} />
          <RefreshButton variant="icon" label="o outbox" busy={entries.loading} onClick={entries.reload} />
        </>
      }
    >
      <ResourceState resource={entries} emptyText="Nada pendente no outbox." />
      {rows.length > 0 && (
        <>
          <OutboxTable entries={rows} />
          <PageFooter
            currentPage={page}
            totalPages={Math.max(1, Math.ceil(total / size))}
            itemsPerPage={size}
            totalElements={total}
            onPageChange={setPage}
            onItemsPerPageChange={changeSize}
            itemsLabel="linhas"
          />
        </>
      )}
    </Section>
  );
};

export default OutboxTab;
